var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]), _vm.isSendWhatsappVisible ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "success",
      size: "mini",
      icon: "el-icon-chat-dot-round"
    },
    on: {
      click: _vm.handleSendWhatsapp
    }
  }, [_vm._v(" Send Whatsapp ")]) : _vm._e(), _vm.createDebitNoteVisible ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "success",
      size: "mini",
      icon: "el-icon-chat-dot-round"
    },
    on: {
      click: _vm.handleCreateDebitNote
    }
  }, [_vm._v(" Create Debit Note ")]) : _vm._e()], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticClass: "fade-in",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      "row-key": "ledgerId",
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Dealer Name",
      prop: "dealerName",
      "min-width": "360",
      "show-overflow-tooltip": "",
      fixed: "left"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Agent",
      prop: "agentName",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(row.agentName || "—") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Invoice No.",
      prop: "invoiceNumber",
      "min-width": "170",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Invoice Date",
      width: "135",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.invoiceDate)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Due Date",
      width: "135",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.dueDate)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Credit Period",
      width: "135",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(row.creditPeriod) + " days ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Invoice Amt",
      width: "155",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatCurrency(row.invoiceAmount)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Settled Amt",
      width: "155",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatCurrency(row.settledAmount)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Outstanding",
      width: "155",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_c("span", {
          staticClass: "outstanding-amt"
        }, [_vm._v(_vm._s(_vm.formatCurrency(row.outstandingAmount)))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Days Old",
      width: "110",
      align: "center",
      prop: "daysOld"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Days Past Due",
      width: "135",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_c("span", {
          staticClass: "days-past-due"
        }, [_vm._v(_vm._s(row.daysPastDue))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Interest",
      width: "135",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatCurrency(row.interest)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Settled By",
      width: "150",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [row.settledBy && row.settledBy.length ? _c("el-button", {
          staticClass: "settled-by-btn",
          attrs: {
            type: "primary",
            round: "",
            size: "medium"
          },
          on: {
            click: function ($event) {
              return _vm.openSettlementDialog(row);
            }
          }
        }, [_vm._v(" " + _vm._s(row.settledBy.length) + " ")]) : _c("span", {
          staticClass: "no-settlement"
        }, [_vm._v("—")])];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  }), _c("el-dialog", {
    attrs: {
      title: "Settlement Details",
      visible: _vm.settlementDialogVisible,
      width: "640px",
      "append-to-body": "",
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.settlementDialogVisible = $event;
      }
    }
  }, [_vm.activeRow ? [_c("div", {
    staticClass: "settlement-summary"
  }, [_c("div", {
    staticClass: "summary-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.activeRow.invoiceNumber))])]), _c("div", {
    staticClass: "summary-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("Invoice Amount")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.activeRow.invoiceAmount)))])]), _c("div", {
    staticClass: "summary-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("Outstanding")]), _c("span", {
    staticClass: "value outstanding-amt"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.activeRow.outstandingAmount)))])])]), _c("el-table", {
    staticStyle: {
      width: "100%",
      "margin-top": "16px"
    },
    attrs: {
      data: _vm.activeRow.settledBy,
      border: "",
      size: "small"
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "#",
      width: "50",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Credit ID",
      prop: "creditId",
      width: "100",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Payment Type",
      prop: "creditPaymentType",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Credit Date",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.creditDate)) + " ")];
      }
    }], null, false, 1057942704)
  }), _c("el-table-column", {
    attrs: {
      label: "Applied Amount",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.formatCurrency(row.appliedAmount)) + " ")];
      }
    }], null, false, 3321720755)
  })], 1)] : _vm._e(), _c("template", {
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.settlementDialogVisible = false;
      }
    }
  }, [_vm._v(" Close ")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };